import { render, staticRenderFns } from "./RoleResume.vue?vue&type=template&id=7512c2b3&scoped=true&"
import script from "./RoleResume.vue?vue&type=script&lang=js&"
export * from "./RoleResume.vue?vue&type=script&lang=js&"
import style0 from "./RoleResume.vue?vue&type=style&index=0&id=7512c2b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512c2b3",
  null
  
)

export default component.exports